import React, { useEffect } from 'react'
import './Latest_Videos.css'
import Common_Back_Header from '../../common/common_components/common_back_header/Common_Back_Header'
import Latest_Card from '../../common/common_components/latest_card/Latest_Card'
import Common_Title_3 from '../../common/common_components/Common_Title_3/Common_Title_3'
import { useDispatch, useSelector } from 'react-redux'
import { AllInsightVideo } from '../../../features/admin/common/Slice'

const All_latest_videos = () => {

    const dispatch = useDispatch();
    const insightVideo = useSelector((state) => state.common.all_insight_videos);


    useEffect(() => {
        dispatch(AllInsightVideo());
    }, [dispatch])

    return (
        <>
            <section className='Latest_Videos'>
                <div className='container'>
                    <Common_Back_Header backNavigation={-1} />

                    {/* <Common_Title_3 titleText={'Latest Videos'} /> */}
                    <div className="row">
                        {insightVideo?.map(
                            ((video, index) => (
                                <div className="col-xl-3 col-md-4 col-sm-6 mb-4" key={index}>
                                    <Latest_Card
                                        mediaContent={
                                            <iframe
                                                className="media_content"
                                                src={video?.link}
                                                title={video?.name}
                                                frameBorder="0"
                                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                referrerPolicy="strict-origin-when-cross-origin"
                                                allowFullScreen
                                            ></iframe>
                                        }
                                        name={video?.name}
                                        description={video?.subname}
                                    />
                                </div>
                            ))
                        )}
                    </div>
                </div>
            </section>
        </>
    )
}

export default All_latest_videos